/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectIcon24Regular = forwardRef('CommentRectIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 7A3.75 3.75 0 0 1 6 3.25h12A3.75 3.75 0 0 1 21.75 7v8A3.75 3.75 0 0 1 18 18.75h-5.569l-4.799 3.49c-.991.721-2.382.013-2.382-1.213v-2.352a3.751 3.751 0 0 1-3-3.675V7ZM6 4.75A2.25 2.25 0 0 0 3.75 7v8A2.25 2.25 0 0 0 6 17.25a.75.75 0 0 1 .75.75v3.027l4.996-3.634a.75.75 0 0 1 .441-.143H18A2.25 2.25 0 0 0 20.25 15V7A2.25 2.25 0 0 0 18 4.75H6Z" })));
});
